import { Component, OnInit, Input } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';

interface dateWithString {
  realDate: Date;
  dateString: string;
  monthNumber: number;
}

@Component({
  selector: 'app-item-begin-at',
  templateUrl: './begin-at.component.html',
  styleUrls: ['./begin-at.component.scss']
})
export class BeginAtComponent implements OnInit {
  // [ From月初日-7日 ] <= begn <= [ MAX( 本日＋7日, To月末日 ) ]
  @Input() searchParams: SearchCondition;
  @Input() open: boolean;
  Months: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  DatesFrom: dateWithString[];
  DatesTo: dateWithString[];
  beginFrom: Date;
  beginTo: Date;
  sevenDays = 7 * 24 * 60 * 60 * 1000;
  constructor() {}

  ngOnInit() {
    if (this.searchParams.begin_from) {
      this.searchParams.begin_from = this.parseDate(
        this.searchParams.begin_from
      ).toLocaleDateString();
    }
    if (this.searchParams.begin_to) {
      this.searchParams.begin_to = this.parseDate(
        this.searchParams.begin_to
      ).toLocaleDateString();
    }
    // 開始月From
    this.DatesFrom = this.setYearMonth(false);
    // 開始月To
    this.DatesTo = this.setYearMonth(true);
  }

  private setYearMonth(
    endOfMonth: boolean = false,
  ): dateWithString[] {
    const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    let dates: dateWithString[] = [];
    months.forEach(month => {
      const d = new Date(
        this.nearestYear(month),
        endOfMonth ? month + 1 : month,
        endOfMonth ? 0 : 1
      );
      dates.push({
        realDate: d,
        dateString: d.toLocaleDateString(),
        monthNumber: d.getMonth() + 1
      });
    });
    return dates;
  }

  // 去年のX月、今年のX月、来年のX月で本日に最も近い X月1日 を当該日付にする(Qmatchと同じ判定ロジック)
  private nearestYear(month: number): number {
    let today = new Date();
    let thisYear = today.getFullYear();

    let todayPoint = today.getTime();
    let thisYearPoint = Math.abs(todayPoint - new Date(thisYear, month, 1).getTime());
    let lastYearPoint = Math.abs(todayPoint - new Date(thisYear - 1, month, 1).getTime());
    let nextYearPoint = Math.abs(todayPoint - new Date(thisYear + 1, month, 1).getTime());

    let pointsArray = [thisYearPoint, lastYearPoint, nextYearPoint];
    // 配列内最小値のインデックスを取得
    let targetYearIndex = pointsArray.indexOf(Math.min(...pointsArray));

    switch (targetYearIndex) {
      case 0:
        // 今年
        return thisYear;
      case 1:
        // 去年
        return thisYear - 1;
      case 2:
        // 来年
        return thisYear + 1;
    }
  }

  parseDate(d: string | null): Date {
    if (d) {
      return new Date(Date.parse(d));
    }
  }

  optionUnAvailable(dateFrom: Date, dateTo: Date): boolean {
    if (dateFrom && dateTo) {
      return dateFrom.valueOf() > dateTo.valueOf();
    }
    return false;
  }
}
